module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[101]588.ef37733.woff2";